import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from 'components/layouts/NotFoundPage';
import LoginPage from 'components/Auth/LoginPage';
import IndexPageComponent from 'components/IndexPage/IndexPage';
import TermsConditions from 'components/StaticPages/TermsConditions';
import { ADMIN } from 'sources/constants/userRoles';
import ContactUsContainer from 'components/StaticPages/ContactUsContainer';
import PrivacyPolicy from 'components/StaticPages/PrivacyPolicy';
import PrivateRoute from './PrivateRoute';
import AdminRoutes from './AdminRoutes';

export const createRoutes = () => (
  <Switch>
    <Route component={IndexPageComponent} path="/" exact />
    <Route component={LoginPage} path="/login" />
    <Route component={TermsConditions} path="/terms" />
    <Route component={PrivacyPolicy} path="/privacy" />
    <Route component={ContactUsContainer} path="/contact" />
    <PrivateRoute Component={AdminRoutes} forRole={ADMIN} />
    <Route path="*" component={NotFoundPage} status={404} />
  </Switch>
);

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx